module.exports = __webpack_public_path__ + "static/img/ht.bef979d7.png";